<template>
  <SFooter
    :menuItems="getStrapiCoreMenu(menuItems)"
    :isShownPrivacyPreferences="getIsShownPrivacyPreferences"
    mainFooterLogoLink="https://sales-lentz.lu/"
    @openCookieDialog="openCookieDialog"
  >
    <template #customLogo>
      <img
        :src="require('@/assets/img/sales-lentz-logo-white.svg')"
        :alt="$t('images.salesLentzLogo')"
      >
    </template>
    <template #customSocial>
      <div />
    </template>
    <template #imgLeft>
      <img
        v-if="getStrapiCoreSettings.footerImgLeft"
        :src="getStrapiCoreSettings.footerImgLeft.url"
        :alt="$t('images.footerSide')"
      >
    </template>
    <template #imgRight>
      <img
        v-if="getStrapiCoreSettings.footerImgRight"
        :src="getStrapiCoreSettings.footerImgRight.url"
        :alt="$t('images.footerSide')"
      >
    </template>
    <template #rights>
      {{ getStrapiCoreSettings.footerRights }}
    </template>
    <template #bottomLeft>
      <VueMarkdown v-if="getStrapiCoreSettings.footerBottomLeft">
        {{ getStrapiCoreSettings.footerBottomLeft }}
      </VueMarkdown>
    </template>
    <template #bottomRight>
      <VueMarkdown v-if="getStrapiCoreSettings.footerBottomRight">
        {{ getStrapiCoreSettings.footerBottomRight }}
      </VueMarkdown>
    </template>
  </SFooter>
</template>

<script lang="ts">
export default {
  name: 'Footer',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { SFooter } from '@slg/web-customer-shared';
import appConfig from '@/appConfig';
import VueMarkdown from 'vue-markdown';
import { useStore, useRouteRef } from '@/composables';

defineProps({
  isFooterFullyShow: {
    type: Boolean,
    default: true,
  },
});

const store = useStore();
const route = useRouteRef();

const isAuth = computed(() => store.getters['auth/getIsAuth']);
const getStrapiCoreMenu = computed(() => store.getters['common/getStrapiCoreMenu']);
const getStrapiCoreSettings = computed(() => store.getters['common/getStrapiCoreSettings']);

const getIsShownPrivacyPreferences = computed(() => appConfig.extendedCookieSupport);

const getPrivacyPolicyPage = computed(() => {
  if (route.value.params.lang === 'de') {
    return 'https://www.slg.lu/de/politique-de-confidentialite/';
  }

  if (route.value.params.lang === 'fr') {
    return 'https://www.slg.lu/politique-de-confidentialite/';
  }

  return 'https://www.slg.lu/en/politique-de-confidentialite/';
});

function generatePathFromRouter(name = '') {
  const { defaultLanguage } = appConfig;
  const lang = route.value.params.lang || defaultLanguage;
  return { name, params: { lang } };
}

const menuItems = computed(() => [
  {
    strapiText: '',
    strapiKey: 'homeTitle',
    isAnotherDomain: false,
    title: 'footer.home',
    path: generatePathFromRouter('Booking'),
  },
  {
    strapiText: '',
    strapiKey: 'FAQTitle',
    isAnotherDomain: false,
    title: 'footer.faq',
    path: generatePathFromRouter('FAQ'),
  },
  {
    strapiText: '',
    strapiKey: 'contactUsTitle',
    isAnotherDomain: false,
    title: 'footer.contactUs',
    path: generatePathFromRouter('ContactUs'),
  },
  {
    strapiText: '',
    isAnotherDomain: true,
    strapiKey: 'policyTitle',
    title: 'footer.privacyPolicy',
    path: { name: getPrivacyPolicyPage.value },
  },
  {
    strapiText: '',
    isAnotherDomain: false,
    strapiKey: 'termsTitle',
    title: 'footer.termsAndConditions',
    path: generatePathFromRouter('TermsAndConditions'),
  },
  {
    strapiText: '',
    isAnotherDomain: false,
    strapiKey: 'sitemapTitle',
    title: 'footer.sitemap',
    path: generatePathFromRouter('Sitemap'),
  },
]);

function openCookieDialog() {
  store.commit('common/changeCookieDialogOpenState', true);
}
</script>
<style lang="scss" scoped>
.footer-additional {
  margin-top: -36px !important;
}
</style>
